
import React, { useEffect, useRef, useState } from 'react';
import config from '../config';
import { DocumentDataProvider, useDocumentData } from '../context/DocumentDataProvider';



const ProjectHeaderEditor: React.FC = ({}) => {
    const [saving, setSaving] = useState(false);
    const [editing, setEditing] = useState(false);
    const {documentData, setDocumentData} = useDocumentData();
    const [name, setName] = useState(documentData.projectName);
    const [description, setDescription] = useState(documentData.projectDescription);

    useEffect(() => {
            setName(documentData.projectName);
            setDescription(documentData.projectDescription);
        }, [documentData]);

    const handleSaveMeta = async () => {
            setSaving(true);
            try {
                const response = await fetch(`${config.API_BASE_URL}/auth/update-project-meta.php`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({
                        project_id: documentData.projectId,
                        name,
                        description,
                    }),
                });
                const data = await response.json();
                if (data.success) {
                    setEditing(false);
                    // Opcional: muestra un mensaje de éxito
                } else {
                    alert('Error updating project: ' + (data.message || 'Unknown error'));
                }
            } catch (err) {
                alert('Network error updating project');
            }
            setSaving(false);
        };

    // Keep a consistent vertical size between edit and view modes.
    const containerStyle: React.CSSProperties = {
        flex: 1,
        minHeight: 10,
        maxHeight:40, 
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 0,
    };

    const viewTitleStyle: React.CSSProperties = { margin: 0, marginTop: 0, fontSize: '1.7em', fontWeight: 600, cursor: 'pointer', display: 'inline-block', color: '#c45151ff', lineHeight: 1 };
    const viewDescStyle: React.CSSProperties = { marginLeft: 10, color: '#555', fontSize: '1.05em', marginTop: 10, cursor: 'pointer', lineHeight: 1 };

    const inputStyle: React.CSSProperties = { width: '100%', fontSize: '1.25em', fontWeight: 600, padding: '6px 1px', boxSizing: 'border-box', height: 24 };
    const textareaStyle: React.CSSProperties = { width: '100%', fontSize: '1em', padding: '6px 1px', boxSizing: 'border-box', height: 24, resize: 'none' };

    return (
        <div style={containerStyle}>
            {editing ? (
                // Layout: left column with inputs, right column with action buttons
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
                        <input
                            value={name}
                            onChange={e => setName(e.target.value)}
                            style={inputStyle}
                            disabled={saving}
                        />
                        <textarea
                            value={description}
                            onChange={e => setDescription(e.target.value)}
                            style={textareaStyle}
                            rows={1}
                            disabled={saving}
                        />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-end' }}>
                        <button onClick={handleSaveMeta} disabled={saving} style={{ padding: '6px 10px' }}>Save</button>
                        <button onClick={() => setEditing(false)} disabled={saving} style={{ padding: '6px 10px' }}>Cancel</button>
                    </div>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <h2
                        style={viewTitleStyle}
                        onClick={() => setEditing(true)}
                        title="Click to change the name"
                    >
                        {name}
                    </h2>
                    <div
                        style={viewDescStyle}
                        onClick={() => setEditing(true)}
                        title="Click to change the description"
                    >
                        {description}
                    </div>
                </div>
            )}
        </div>
    );
};


export default ProjectHeaderEditor;